import App from "@bloglovin/inspire-engine/App";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { readBoundContextName, resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";

const SHOW_ENTITY_TYPE = "Show";

const EMPTY_SHOW_ENTITY = Object.freeze({
  id: 0,
  title: "",
  type: "",
  description: "",
  coverImage: "",
  numSeasons: 0,
  genres: [],
});

export const BaseShowCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
    scopedProvidedContexts: { default: null },
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    boundContextName() {
      return readBoundContextName(this);
    },
    showEntityId() {
      return resolveBoundEntityId(this, "show");
    },
    hasResolvedShowEntity() {
      const id = this.showEntityId;
      if (!id) {
        return false;
      }
      const entity = App.get(contextualAppName()).getEntity(SHOW_ENTITY_TYPE, { id });
      return Boolean(entity && entity.isHydrated);
    },
  },
  methods: {
    getExampleEntity() {
      return {
        id: 1,
        title: "Demo Show",
        type: "series",
        description: "A demo show description.",
        coverImage: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
        numSeasons: 3,
        genres: ["Drama", "Comedy"],
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.showEntityId;
      if (!id) {
        return EMPTY_SHOW_ENTITY;
      }
      const entity = App.get(contextualAppName()).getEntity(SHOW_ENTITY_TYPE, { id });
      return entity || EMPTY_SHOW_ENTITY;
    },
  },
};
